/**
 * @file: 商品渲染状态切换
 * @author: xiaolong.huang@dmall.com
 */

import * as UIToolkit from '../../../UIToolkit/index';
import * as Toolkit from '../../../toolkit/index';
import Config from '../../../config/index';
import FrontCubeData from '../../../frontCubeData/index';

interface Color {
    background: string,
    font: string
}

export function statusSwitch(cube: CubeNode): void {
    // 渲染模式切换
    toggleRenderModel(cube);

    // 文字显示切换
    toggleTxtVisible(cube);

    // 色值渲染
    renderColor(cube);
}

// 渲染模式
function toggleRenderModel(cube: CubeNode): void {
    let $el: JQuery<HTMLElement> = cube.jView;
    let $mainGoodsTxt: JQuery<HTMLElement> = $el.find('.default-tags');
    let $subGoodsTxt: JQuery<HTMLElement> = $el.find('.sub_tags');
    let $goodsColor: JQuery<HTMLElement> = $el.find('.shelvesbuild-e-g-default__goods-color');

    if (UIToolkit.isTxTModel() || UIToolkit.isColorModel()) {
        // 主商品文字显示
        $mainGoodsTxt.removeClass('hide').addClass('show');

        // 主商品背景色块显示
        $goodsColor.removeClass('hide').addClass('show');

        // 字码商品文字显示
        $subGoodsTxt.removeClass('hide').addClass('show');
    }
    else {
        // 主商品文字隐藏
        $mainGoodsTxt.removeClass('show').addClass('hide');

        // 主商品背景色块隐藏
        $goodsColor.removeClass('show').addClass('hide');

        // 字码商品文字隐藏
        $subGoodsTxt.removeClass('show').addClass('hide');
    }
}

// 文字显示切换
function toggleTxtVisible(cube: CubeNode): void {
    let $el: JQuery<HTMLElement> = cube.jView;
    let $mainGoodsTxt: JQuery<HTMLElement> = $el.find('.default-tags');
    let $subGoodsTxt: JQuery<HTMLElement> = $el.find('.sub_tags');

    if (UIToolkit.tagIsChecked()) {
        Toolkit.html($mainGoodsTxt, $mainGoodsTxt.attr('title'));
        Toolkit.html($subGoodsTxt, $subGoodsTxt.attr('title'));
        return;
    }
    Toolkit.html($mainGoodsTxt, '');
    Toolkit.html($subGoodsTxt, '');
}

function renderColor(cube: CubeNode): void {
    // 主商品色值渲染
    setMainGoodsColor(cube);

    // 字码商品色值渲染
    setSubGoodsColor(cube);
}

// 主商品色值渲染
function setMainGoodsColor(cube: CubeNode): void {
    let $el: JQuery<HTMLElement> = cube.jView;
    let subSkuList: Array<SkuData> = FrontCubeData.getValue(cube.id, 'subSkuList');
    let color: Color = getGoodsColor(subSkuList[0]);
    let $mainGoodsColor: JQuery<HTMLElement> = $el.find('.g-center .shelvesbuild-e-g-default__goods-color');
    let $mainGoodsTxt: JQuery<HTMLElement> = $el.find('.default-tags');
    let $xGoodsColor: JQuery<HTMLElement> = $el.find('.g-right .shelvesbuild-e-g-default__goods-color');
    let $yGoodsColor: JQuery<HTMLElement> = $el.find('.g-top .shelvesbuild-e-g-default__goods-color');

    $mainGoodsColor.css({
        background: color.background
    });
    $xGoodsColor.css({
        background: color.background
    });
    $yGoodsColor.css({
        background: color.background
    });
    $mainGoodsTxt.css({
        color: color.font
    });
}

// 字码商品色值渲染
function setSubGoodsColor(cube: CubeNode): void {
    let $el: JQuery<HTMLElement> = cube.jView;
    let subSkuList: Array<SkuData> = FrontCubeData.getValue(cube.id, 'subSkuList');

    for (let i: number = 1; i < subSkuList.length; i++) {
        let color: Color = getGoodsColor(subSkuList[i]);
        let $subGoodsTxt: JQuery<HTMLElement> = $el.find(`.sub_tags.sub_${i}`);

        $subGoodsTxt.css({
            background: color.background,
            color: color.font
        });
    }
}

// 色值计算
function getGoodsColor(sku: SkuData): Color {
    let result: Color = {
        background: '#fff',
        font: '#000'
    };
    if (UIToolkit.isTxTModel()) {
        return result;
    }

    // 对应渲染的品牌数据库
    let brandData: FreeObjMap|null = Config.getGlobalConfig('BRAND_DATA') || null;

    // 对应渲染的品牌数据库
    let benderBrandAndEnum: FreeObjMap|null = Config.getGlobalConfig('RENDER_BRAND_ENUM') || null;
   

    if (brandData[sku.skuId] && benderBrandAndEnum[brandData[sku.skuId]]) {
        result.background = benderBrandAndEnum[brandData[sku.skuId]].color;
        result.font = benderBrandAndEnum[brandData[sku.skuId]].fontColor;
    }

    return result;
}
